<template>
    <auth-layout :isPlain="true" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-page-header
                :heading="$t('pages.errors.not_found.heading')"
                :content="$t('pages.errors.not_found.content')"
            ></common-page-header>
        </common-content-wrapper>

        <common-content-wrapper width="small">
            <common-button
                :label="$t('common.microcopy.back_to_home')"
                :route="{ name: 'index' }"
                type="primary"
                size="large"
            ></common-button>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import AuthLayout from 'components/layouts/AuthLayout'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            AuthLayout,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.errors.not_found.title')
            },
        },
    }
</script>
